export default function addTrailingSlash(url) {
  if (url.endsWith('/')) return url

  return `${url}/`
}
